import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { LEGACY_MODE, LegacyModeConfig } from '@boldpenguin/emperor-services';
import { EmperorCardComponent } from './card.component';
import { EmperorCardContentComponent } from './components/card-content/card-content.component';
import { EmperorCardFooterComponent } from './components/card-footer/card-footer.component';
import { EmperorCardHeaderComponent } from './components/card-header/card-header.component';

export * from './card.component';
export * from './components/card-content/card-content.component';
export * from './components/card-footer/card-footer.component';
export * from './components/card-header/card-header.component';

const declarations = [
  EmperorCardComponent,
  EmperorCardHeaderComponent,
  EmperorCardFooterComponent,
  EmperorCardContentComponent,
];

@NgModule({
  declarations,
  exports: declarations,
  imports: [CommonModule, MatCardModule],
  providers: [
    {
      provide: LEGACY_MODE,
      useValue: true,
    },
  ],
})
export class EmperorCardModule {
  static forRoot(
    config?: LegacyModeConfig | undefined,
  ): ModuleWithProviders<EmperorCardModule> {
    return {
      ngModule: EmperorCardModule,
      providers: [
        { provide: LEGACY_MODE, useValue: config?.legacyMode ?? true },
      ],
    };
  }
}
